
import { Component, Vue, Prop } from 'vue-property-decorator';
import { iImagesList } from '@/interface/exchange-code';
// import { login } from '@/api/users';
import InputType from './input-type.vue';
@Component({
  components: { InputType },
})
export default class extends Vue {
  @Prop({ default: '.png,.jpg' }) type!: string;
  @Prop({ default: '1' }) size!: string;
  @Prop() keyIndex!: number;
  @Prop({ default: false }) invaildH!: boolean;
  @Prop({ default: 211 }) maxH!: number;
  @Prop({ default: 520 }) maxW!: number;
  @Prop() images!: iImagesList;
  @Prop() fillText1!: string;
  @Prop() isDelete?: boolean;
  @Prop({ default: true }) uploadeShow?: boolean | true;
  @Prop() imagesList?: iImagesList[];

  beforeImgUpLoad(file: any) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        let data = e.target.result;
        //加载图片获取图片真实宽度和高度
        let image = new Image();
        image.onload = async () => {
          let width = image.width;
          let height = image.height;
          file.image_height = height;
          file.image_width = width;
          let isPass = await this.uploadRules(file);
          if (!isPass) {
            reject();
          } else {
            resolve();
          }
        };
        image.src = data;
      };
      reader.readAsDataURL(file);
    }).then(
      () => {
        return file;
      },
      () => {
        return Promise.reject();
      }
    );
  }

  uploadRules(file: any) {
    return new Promise(resolve => {
      const isLt2M = file.size / 1024 / 1024 < Number(this.size);
      const isJPG = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
      let istype = this.type.includes(`${isJPG}`);
      if (!istype) {
        this.$message.error(`图片格式仅支持 ${this.type} 格式，请重新上传`);
        resolve(false);
      }
      if ((this.invaildH ? false : file.image_height !== Number(this.maxH)) || file.image_width !== Number(this.maxW)) {
        this.$message.error('图片尺寸不符合要求，请重新上传!');
        resolve(false);
      }
      if (!isLt2M) {
        this.$message.error(`图片大小不能超过${this.size}MB`);
        resolve(false);
      }
      resolve(true);
    });
  }
  uploadSuccess(file: any) {
    let files = file.status;
    this.images.imageUrl = files.preview_url;
  }
  deleteForm() {
    //this.$emit('deleteForm');
    this.imagesList!.splice(this.keyIndex, 1);
  }
  mounted() {
    // console.log('dee');
    // console.log(this.images);
    // console.log(this.fillText1);
  }
}
